import Avatar from "src/components/Avatar";
import Select from "src/components/field/fields/Select";
import { WrapperProps } from "src/components/field/utils/Wrapper";
import useConnections from "src/hooks/api/services/users/useConnections";

interface ConnectionProps {
	isClearable?: boolean;
	wrapper?: WrapperProps;
	value?: number;
	onChange: (value?: number) => void;
}

const Connection = ({
	isClearable,
	wrapper,
	value,
	onChange,
}: ConnectionProps) => {
	const { connections, status, search, actions } = useConnections();

	return (
		<Select
			{...{ wrapper, isClearable }}
			value={value ? value.toString() : undefined}
			onChange={(value) => onChange(value ? Number(value) : undefined)}
			search={{
				onChange: actions.search,
				value: search,
				loading: status !== "idle",
				autoFocus: true,
			}}
			options={connections.map((user) => ({
				value: user.id.toString(),
				label: (
					<>
						<Avatar src={user.avatar} size="xsmall" />
						<span className="flex-1">{user.full_name}</span>
					</>
				),
			}))}
		/>
	);
};

export default Connection;
